import axios from 'axios';
import { getToken } from './auth';

const API_URL = 'https://backend.chamafruits.com';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getTaxes = async (params = {}) =>
  (await axios.get(`${API_URL}/taxes`, { ...withAuth(), params })).data;

export const createTax = async (payload) =>
  (await axios.post(`${API_URL}/taxes`, payload, withAuth())).data;

export const updateTax = async (taxId, payload) =>
  (await axios.patch(`${API_URL}/taxes/${taxId}`, payload, withAuth())).data;

export const getBranchTaxes = async (branchId) =>
  (await axios.get(`${API_URL}/branch/${branchId}/taxes`, withAuth())).data;

export const updateBranchTaxes = async (branchId, payload) =>
  (await axios.put(`${API_URL}/branch/${branchId}/taxes`, payload, withAuth())).data;
